"use client";

import { useEffect } from "react";

/**
 * Layout for the /en subtree. Forces the app locale to English so every page
 * rendered under /en (which reads locale via getLocale()/useTranslations from
 * cookie/localStorage) shows English content. Pages that take an explicit
 * `lang` prop still work; this covers the rest.
 */
export default function EnLayout({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    try {
      localStorage.setItem("locale", "en");
      const expires = new Date(Date.now() + 365 * 864e5).toUTCString();
      document.cookie = `locale=en; expires=${expires}; path=/; SameSite=Lax`;
      document.documentElement.lang = "en";
      window.dispatchEvent(new CustomEvent("localeChange", { detail: "en" }));
    } catch {
      /* no-op */
    }
  }, []);

  return <>{children}</>;
}
